import {useState} from 'react';

import {Sync as SyncIcon} from '@mui/icons-material';
import {Typography, useTheme} from '@mui/material';
import Grid from '@mui/material/Grid';

import {BREAKPOINTS, FONT_FAMILIES, REPORT_PARAMETERS_ACCORDIONS_IDS} from '../../../../const';
import useBreakpoint from '../../../../hooks/dom/useBreakpoint';
import useReportParameters from '../../../../hooks/providers/useReportParameters';
import Button from '../../../form/buttons/Button/Button';
import CategoryAccordion from '../../shared/CategoryAccordion/CategoryAccordion';
import CategoryAccordionIcon from '../../shared/CategoryAccordionIcon/CategoryAccordionIcon';
import ActualizeAllSourcesButton from '../ActualizeAllSourcesButton/ActualizeAllSourcesButton';
import AllSourcesStatusChip from '../AllSourcesStatusChip/AllSourcesStatusChip';
import BetaVersionChip from '../BetaVersionChip/BetaVersionChip';
import SingleSource from '../SingleSource/SingleSource';

const Sources = () => {
  const theme = useTheme();
  const currentBreakpoint = useBreakpoint();
  const isExtraSmallScreen = currentBreakpoint === BREAKPOINTS.xs;

  const [isActualizing, setActualizing] = useState(false);

  const {isGatewayDatasourceCurrentlyTested, currentReport, getGateways, testGatewayDatasourceConnection, reportParametersCategoryExpanded, reportDataSources} = useReportParameters();

  const numberOfSources = reportDataSources.length || 0;
  const plural = numberOfSources > 1 ? 's' : '';
  const subtitle = `${numberOfSources} source${plural} configurée${plural}`;
  const isExpanded = reportParametersCategoryExpanded === REPORT_PARAMETERS_ACCORDIONS_IDS.DATA_SOURCES;
  const shouldDisplaySourcesChip = reportDataSources.length > 0;

  const handleActualizeAllSources = async e => {
    e.stopPropagation();
    setActualizing(true);
    await getGateways(currentReport);
    setActualizing(false);
  };

  const handleTestConnection = source => {
    const sourceData = {
      id: source.id,
      gateway_id: source.gatewayId,
      workspace_id: currentReport.workspace_id,
      dataset_id: currentReport.dataset_id,
      report_id: currentReport.report_id
    };
    const datasources = [sourceData];
    testGatewayDatasourceConnection(datasources);
  };

  const renderActionsSection = () => {
    return (
      <Grid item mr={1}>
        <Grid container alignItems="center" gap={0.5}>
          {shouldDisplaySourcesChip && <AllSourcesStatusChip />}
          <ActualizeAllSourcesButton disabled={isActualizing} onClick={handleActualizeAllSources} />
        </Grid>
      </Grid>
    );
  };

  return (
    <CategoryAccordion
      disabled={reportDataSources.length === 0}
      id={REPORT_PARAMETERS_ACCORDIONS_IDS.DATA_SOURCES}
      icon={<CategoryAccordionIcon iconName="SdStorage" color={theme.palette.primary.main} />}
      title={
        <Grid flexWrap="nowrap" gap={1} container alignItems="center">
          <Typography fontSize={17} fontFamily={FONT_FAMILIES.TITLE}>
            Source de données
          </Typography>
          <BetaVersionChip />
        </Grid>
      }
      subtitle={subtitle}
      expanded={isExpanded}
      renderActionsSection={renderActionsSection}
    >
      {reportDataSources.map(source => (
        <SingleSource key={source.id} source={source} testConnection={() => handleTestConnection(source)} isTestingConnection={isGatewayDatasourceCurrentlyTested(source.id, source.gatewayId)} />
      ))}
    </CategoryAccordion>
  );
};

export default Sources;
